import {setCacheNameDetails as workbox_core_setCacheNameDetails} from 'E:/wamp64/www/git/absolute-fleet-management/absolute-admin-old/absolute-fleet-management-v1/node_modules/workbox-core/setCacheNameDetails.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'E:/wamp64/www/git/absolute-fleet-management/absolute-admin-old/absolute-fleet-management-v1/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "Absolute"});


self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/assets/absolutelogo.jpg",
    "revision": "b6e7d3bc2591d68d5319311a9322b919"
  },
  {
    "url": "/assets/car.png",
    "revision": "45aea235dc2fa90581e6a9c94be8d476"
  },
  {
    "url": "/assets/css/style.css",
    "revision": "cb492b7df9b5c170d7c87527940eff3b"
  },
  {
    "url": "/assets/icon.png",
    "revision": "02bcca815102ad6d8a7eb14d3ce4503e"
  },
  {
    "url": "/assets/icons/driver.svg",
    "revision": "21f3f7d232cc3ade5ac0123a55c98fa0"
  },
  {
    "url": "/assets/images/logo/logo.png",
    "revision": "23e2946573540d73cf4f7f5391396408"
  },
  {
    "url": "/assets/images/no_user.png",
    "revision": "bb163fc92232e706e989c7a442daeb0e"
  },
  {
    "url": "/assets/images/passengerbg.png",
    "revision": "d405d3cd7a76850600ec0247a4396109"
  },
  {
    "url": "/assets/images/profile.webp",
    "revision": "b6f430b1bc57dc4592cba07501b7f6a8"
  },
  {
    "url": "/assets/notif.wav",
    "revision": "a3312b844234a83e688a2070e73f1fb7"
  },
  {
    "url": "/assets/tone.mp3",
    "revision": "b506a66a688dd0df4b191f1ff1611c45"
  },
  {
    "url": "/css/app.21bd68d7.css",
    "revision": null
  },
  {
    "url": "/css/chunk-vendors.42c92ffb.css",
    "revision": null
  },
  {
    "url": "/family/KFOkCnqEu92Fr1MmgVxEIzIFKw.woff2",
    "revision": "e1342abeed9ac6cb48cb1d7e32c86d2f"
  },
  {
    "url": "/family/KFOkCnqEu92Fr1MmgVxFIzIFKw.woff2",
    "revision": "29547e4823946bcd1e8c30ac31dfa7ef"
  },
  {
    "url": "/family/KFOkCnqEu92Fr1MmgVxGIzIFKw.woff2",
    "revision": "cde68d64494f01d356db8e6369371916"
  },
  {
    "url": "/family/KFOkCnqEu92Fr1MmgVxHIzIFKw.woff2",
    "revision": "99a3869b942a37571d4e0761ac2a72e7"
  },
  {
    "url": "/family/KFOkCnqEu92Fr1MmgVxIIzI.woff2",
    "revision": "603b8950590bf833546eee7cbc79944a"
  },
  {
    "url": "/family/KFOkCnqEu92Fr1MmgVxLIzIFKw.woff2",
    "revision": "31003a41f1d97bc61e65f4c3c3fe6de0"
  },
  {
    "url": "/family/KFOkCnqEu92Fr1MmgVxMIzIFKw.woff2",
    "revision": "4f18a79f04379b289911c0113c2a447a"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmEU9fABc4EsA.woff2",
    "revision": "7b08b9e11fc6b8a8a1398b357e874144"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmEU9fBBc4.woff2",
    "revision": "3a44e06eb954b96aa043227f3534189d"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmEU9fBxc4EsA.woff2",
    "revision": "53f395eb854a40e978706b1082570e42"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmEU9fCBc4EsA.woff2",
    "revision": "e7b7001dff6c14165abdc0fefdecae06"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmEU9fCRc4EsA.woff2",
    "revision": "2742d81afb69e902e4513dc7cdda0a7f"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmEU9fChc4EsA.woff2",
    "revision": "e36fccd06262bef92e7a9841e2202225"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmEU9fCxc4EsA.woff2",
    "revision": "7cda2cfee99d697daf8c14819d9004eb"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmSU5fABc4EsA.woff2",
    "revision": "9b9ec29522d1bf8924ccc2d917e1807b"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmSU5fBBc4.woff2",
    "revision": "b9c29351c46f3e8c8631c4002457f48a"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmSU5fBxc4EsA.woff2",
    "revision": "dcdaee374d5bbeab0a5ed5c8cf39a6cd"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmSU5fCBc4EsA.woff2",
    "revision": "c2be5367fbf0e1066261fd78eb103f4a"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmSU5fCRc4EsA.woff2",
    "revision": "d04413353a32aed8a0db452373452870"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmSU5fChc4EsA.woff2",
    "revision": "716871ec15f054ec158445180fe280e1"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmSU5fCxc4EsA.woff2",
    "revision": "48c684d99330969e3ce90b9e9da2d698"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmWUlfABc4EsA.woff2",
    "revision": "6f112ec2b932ee12379442c42853244e"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmWUlfBBc4.woff2",
    "revision": "e9f5aaf547f165386cd313b995dddd8e"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmWUlfBxc4EsA.woff2",
    "revision": "3f8b2aa43c439ca2c8930c198320c231"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmWUlfCBc4EsA.woff2",
    "revision": "2953af0021626d3c3078b17590118908"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmWUlfCRc4EsA.woff2",
    "revision": "e0bc9313fdde7851c88c901baf3c2b5c"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmWUlfChc4EsA.woff2",
    "revision": "deb26e9b1a25438118e5d39d741ae6b6"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmWUlfCxc4EsA.woff2",
    "revision": "cdaab83619fcacd4027a77c99dd51e69"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmYUtfABc4EsA.woff2",
    "revision": "164a322c3a8ec10a523be51659d36c73"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmYUtfBBc4.woff2",
    "revision": "b20371a6daf29d4a1f2e85dbbf40fb20"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmYUtfBxc4EsA.woff2",
    "revision": "b6fcbac32149e03f24afc9ddce02b093"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmYUtfCBc4EsA.woff2",
    "revision": "19d1156848d47fd3eee7c60fcd3effa1"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmYUtfCRc4EsA.woff2",
    "revision": "83ddac844cd7f981cf6b455b959d3ede"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmYUtfChc4EsA.woff2",
    "revision": "e4de912dacec9bf5c6b3cf0a3fe55c06"
  },
  {
    "url": "/family/KFOlCnqEu92Fr1MmYUtfCxc4EsA.woff2",
    "revision": "6f623ab6fb9356a3f9c38af021f48892"
  },
  {
    "url": "/family/KFOmCnqEu92Fr1Mu4WxKOzY.woff2",
    "revision": "28668857bef1b85c5748a482cf9b74af"
  },
  {
    "url": "/family/KFOmCnqEu92Fr1Mu4mxK.woff2",
    "revision": "15d9f621c3bd1599f0169dcf0bd5e63e"
  },
  {
    "url": "/family/KFOmCnqEu92Fr1Mu5mxKOzY.woff2",
    "revision": "d9ac47c7e500fb7083b8d595eaf6fe12"
  },
  {
    "url": "/family/KFOmCnqEu92Fr1Mu72xKOzY.woff2",
    "revision": "c00467dc3792a8ab586955a3faefcac9"
  },
  {
    "url": "/family/KFOmCnqEu92Fr1Mu7GxKOzY.woff2",
    "revision": "87ace20058325aa069320aa4af875dff"
  },
  {
    "url": "/family/KFOmCnqEu92Fr1Mu7WxKOzY.woff2",
    "revision": "ca3b09b62fda648a4511700413313fd0"
  },
  {
    "url": "/family/KFOmCnqEu92Fr1Mu7mxKOzY.woff2",
    "revision": "35de3738b76d249ed060dd3d0f9286be"
  },
  {
    "url": "/family/roboto.css",
    "revision": "56cc9fd02bc6fcc5faf3f777f2e034ee"
  },
  {
    "url": "/fonts/avenir-400.woff2",
    "revision": "ca8c2af7f604634390ef3e68b80fa189"
  },
  {
    "url": "/fonts/avenir-500.woff2",
    "revision": "433d4bcf95a373b63ba59713a2167d42"
  },
  {
    "url": "/fonts/avenir-600.woff2",
    "revision": "7c0278113ae5f34e8198a2cea65c3bac"
  },
  {
    "url": "/fonts/materialdesignicons-webfont.eot",
    "revision": "8ced95a05e3c82d7b6ef6cd3f31c7ccb"
  },
  {
    "url": "/fonts/materialdesignicons-webfont.ttf",
    "revision": "6e435534bd35da5fef04168860a9b8fa"
  },
  {
    "url": "/fonts/materialdesignicons-webfont.woff2",
    "revision": "1d7bcee1b302339c3b8db10214dc9ec6"
  },
  {
    "url": "/fonts/mdi.css",
    "revision": "e5819d8fcd08f86ce066759f1b394764"
  },
  {
    "url": "/img/data.52fbe0f8.svg",
    "revision": null
  },
  {
    "url": "/img/icon.cb02a491.png",
    "revision": null
  },
  {
    "url": "/img/no_user.60a45c30.png",
    "revision": null
  },
  {
    "url": "/img/send.9c39d0f0.svg",
    "revision": null
  },
  {
    "url": "/index.html",
    "revision": "d172ab64ab542b00a1e892508dd372f3"
  },
  {
    "url": "/js/app.ca54b58f.js",
    "revision": null
  },
  {
    "url": "/manifest.json",
    "revision": "d6bcadeccd2ff0c8851b47ad434a84f8"
  },
  {
    "url": "/robots.txt",
    "revision": "735ab4f94fbcd57074377afca324c813"
  }
], {});








